/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { TabBarComponent } from './tab-bar';
export * from './tab-bar-adapter';
export * from './tab-bar-constants';
export * from './tab-bar-core';
export * from './tab-bar';
export function defineTabBarComponent() {
    defineCustomElement(TabBarComponent);
}
